<div
  id="organization"
  class="page-layout simple left-sidebar inner-sidebar inner-scroll"
>
  <!-- HEADER -->
  <div class="gt2-theme">
    <div
      class="header accent py-24 pl-24 pr-8 mat-elevation-z1 organization-header"
      fusePerfectScrollbar
    >
      <div class="flex-row-start-center">
        <button
          class="mr-0 mr-sm-16 white-fg organization-back-btn organization-back-btn-desktop"
          mat-icon-button
          (click)="onPageBack(location, router)"
        >
          <mat-icon class="icon-mat">arrow_back</mat-icon>
        </button>
        <mat-icon class="header-page-icon">account_balance</mat-icon>
        <div class="flex-column-start-start">
          <div class="user-info flex-row-start-start">
            <div
              class="organization-title"
              *fuseIfOnDom
              [@animate]="{
                value: '*',
                params: { delay: '100ms', x: '-25px' },
              }"
            >
              <div *ngIf="organization" class="">
                <span class="text-truncate">
                  {{ organization.name | uppercase }}
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="organization" class="flex-row-start-start">
            {{ "GENERIC.ORGANIZATION" | translate }}
          </div>
        </div>
      </div>

      <div class="flex-row-start-center">
        <button
          class="mr-8 white-fg organization-back-btn organization-back-btn-mobile"
          mat-icon-button
          (click)="onPageBack(location, router)"
        >
          <mat-icon class="icon-mat">arrow_back</mat-icon>
        </button>
        <button
          mat-button
          matTooltip="{{ 'GENERIC.OPEN_NEW_TAB' | translate }}"
          (click)="onOpenInNewTab()"
          class="mat-icon-button"
          *hideOn="'mobile'"
        >
          <mat-icon class="s-30 icon-mat">{{ getIcon("NEW_TAB") }}</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!-- / HEADER -->

  <!-- SUB HEADER -->
  <div
    *ngIf="organization"
    fusePerfectScrollbar
    style="min-height: 50px"
    class="primary mat-elevation-z1 py-8 gt2-sub-header content-subheader flex-row-end-center"
  >
    <button
      mat-button
      class="gt2-sub-header-button"
      (click)="onManageTaxNumbers()"
    >
      <mat-icon class="icon-mat s-24">receipt_long</mat-icon>
      <span class="ml-8 icon-mat">
        {{ "ORG.MANAGE_TAX_NUMBERS" | translate }}
      </span>
    </button>
  </div>
  <!-- / SUB HEADER -->

  <!--HISTORY SIDEBAR-->
  <!-- <fuse-sidebar name="productHistoryPanel" position="right" class="section-history-panel">
            <app-section-history-panel panelName="productHistoryPanel" section="products" sectionUUID="{{productID}}"></app-section-history-panel>
        </fuse-sidebar> -->

  <div class="content">
    <!--HISTORY SIDEBAR BUTTON-->
    <!-- <div *ngxPermissionsOnly="['GOD']">
                <button mat-icon-button class="warn mat-elevation-z2 historic-button" *fuseIfOnDom [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}"
                    (click)="toggleHistoricSidebarOpen('productHistoryPanel')">
                    <mat-icon>history</mat-icon>
                </button>
            </div> -->

    <!-- CENTER -->
    <div class="center p-24 pb-56 pr-sm-72" #mainContainer>
      <!-- CONTENT -->
      <div class="caterer-content flex-column">
        <!-- INFORMATION -->
        <div class="profile-box info-box general mt-12 flex-column">
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">
                {{ "GENERIC.GENERAL_INFORMATION" | translate }}
              </div>
            </header>
          </div>
          <div class="content">
            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.NAME" | translate }}</div>
                <div class="info text-truncate">{{ organization.name }}</div>
                <div *ngIf="!organization.name" class="info empty-value"></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.NAME" | translate }}</mat-label>
                      <input
                        matInput
                        autocomplete="nope"
                        formControlName="name"
                        type="text"
                        [(ngModel)]="organizationName"
                        required
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['name'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.WEBSITE" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.website | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.website"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.WEBSITE" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="website"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.website"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['website'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.FACEBOOK" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.facebook_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.facebook_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.FACEBOOK" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="facebook_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.facebook_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['facebook_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.TWITTER" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.twitter_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.twitter_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.TWITTER" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="twitter_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.twitter_url"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['twitter_url'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.LINKEDIN" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.linkedin_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.linkedin_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.LINKEDIN" | translate
                      }}</mat-label>
                      <input
                        matInput
                        autocomplete="nope"
                        formControlName="linkedin_url"
                        type="text"
                        [(ngModel)]="organization.linkedin_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['linkedin_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.INSTAGRAM" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.instagram_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.instagram_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.INSTAGRAM" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="instagram_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.instagram_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['instagram_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-50p">
                <div class="title">{{ "GENERIC.YOUTUBE" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.youtube_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.youtube_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.YOUTUBE" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="youtube_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.youtube_url"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['youtube_url'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.TELEGRAM" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.telegram_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.telegram_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.TELEGRAM" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="telegram_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.telegram_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['telegram_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.TIKTOK" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.tiktok_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.tiktok_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.TIKTOK" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="tiktok_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.tiktok_url"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['tiktok_url'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.WHATSAPP" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.whatsapp_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.whatsapp_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.WHATSAPP" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="whatsapp_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.whatsapp_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['whatsapp_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.PINTEREST" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.pinterest_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.pinterest_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "GENERIC.PINTEREST" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="pinterest_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.pinterest_url"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['pinterest_url'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "GENERIC.THREADS" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.threads_url | displayHtmlLinkPipe }}
                </div>
                <div
                  *ngIf="!organization.threads_url"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "GENERIC.THREADS" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="threads_url"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.threads_url"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['threads_url'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="organization"
              class="flex-row-start-start fxLayout-column-xs"
            >
              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "ORG.SUPPORT_EMAIL" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.support_email }}
                </div>
                <div
                  *ngIf="!organization.support_email"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{
                        "ORG.SUPPORT_EMAIL" | translate
                      }}</mat-label>
                      <input
                        matInput
                        formControlName="support_email"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.support_email"
                      />
                      <mat-error
                        *ngIf="
                          organizationForm.controls['support_email'].invalid
                        "
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div *ngIf="!editMode" class="info-line fxFlex-100p">
                <div class="title">{{ "ORG.SUPPORT_TEL" | translate }}</div>
                <div class="info text-truncate">
                  {{ organization.support_tel }}
                </div>
                <div
                  *ngIf="!organization.support_tel"
                  class="info empty-value"
                ></div>
              </div>
              <div *ngIf="editMode" class="info-line fxFlex-50p">
                <div class="info-editable">
                  <div [formGroup]="organizationForm" class="">
                    <mat-form-field class="form-input-container fxFlex-100p">
                      <mat-label>{{ "ORG.SUPPORT_TEL" | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="support_tel"
                        type="text"
                        autocomplete="nope"
                        [(ngModel)]="organization.support_tel"
                      />
                      <mat-error
                        *ngIf="organizationForm.controls['support_tel'].invalid"
                        >{{ "GENERIC.INPUT_LENGTH_INVALID" | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="editMode" class="mt-16 flex-row-end-start">
              <button
                (click)="onManualSaveOrganization()"
                color="accent"
                class="save-btn"
                [disabled]="organizationForm.invalid"
                mat-raised-button
              >
                {{ "GENERIC.SAVE" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- SIGNATURE -->
        <div
          *ngIf="organization"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "ORG.SIGNATURE" | translate }}</div>
            </header>
          </div>
          <div class="content">
            <app-signature-rich-editor
              [editMode]="editMode"
              [(signatureFr)]="organization.signature_fr_CA"
              [(signatureEn)]="organization.signature_en_CA"
            ></app-signature-rich-editor>
            <div *ngIf="editMode" class="mt-16 flex-row-end-start">
              <button
                (click)="onSaveSignature()"
                color="accent"
                class="save-btn"
                [disabled]="loading"
                mat-raised-button
              >
                {{ "GENERIC.SAVE" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- COULEURS -->
        <div
          *ngIf="organization"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "ORG.COLORS" | translate }}</div>
            </header>
          </div>
          <div class="content">
            <div class="info-line fxFlex-100p">
              <div class="title">{{ "ORG.EMAIL_BG_COLOR" | translate }}</div>
              <div
                *ngxPermissionsOnly="P.CONFIG_ORGANIZATION"
                class="flex-row-start-center email-bg-color-controls mt-8"
              >
                <ngx-colors
                  ngx-colors-trigger
                  [(ngModel)]="emailBackgroundColor"
                  [style.background]="
                    organization.email_background_color || '#ffffff'
                  "
                  (input)="setEmailBackgroundColor($event)"
                  [palette]="colorPalette"
                  [hideColorPicker]="true"
                  [hideTextInput]="false"
                ></ngx-colors>
                <div
                  class="color-preview"
                  *ngIf="organization.email_background_color"
                  [style.background]="organization.email_background_color"
                >
                  <span>Aa</span>
                </div>
                <button
                  mat-button
                  *ngIf="organization.email_background_color"
                  (click)="clearEmailBackgroundColor()"
                >
                  {{ "ORG.EMAIL_BG_COLOR_CLEAR" | translate }}
                </button>
              </div>
              <div class="logo-requirement">
                {{ "ORG.EMAIL_BG_COLOR_HELP" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- ADDRESS -->
        <div
          *ngIf="organization"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "GENERIC.ADDRESS" | translate }}</div>
            </header>
          </div>
          <div class="">
            <app-address
              #addressComponent
              [groupModel]="organization.address"
              [isVisible]="true"
              [allowPoBox]="true"
              [editMode]="false"
              [useAutosave]="false"
              class=""
            ></app-address>
          </div>
        </div>

        <!-- CONTACT -->
        <div
          *ngIf="organization"
          class="profile-box info-box general mt-12 flex-column"
        >
          <div class="gt2-org-theme">
            <header class="accent">
              <div class="title">{{ "GENERIC.CONTACT" | translate }}</div>
            </header>
          </div>
          <div class="">
            <app-contact
              #contactComponent
              [groupModel]="organization.contact"
              [editMode]="false"
              [useAutosave]="false"
              class=""
            >
            </app-contact>
          </div>
        </div>

        <!-- <div *ngIf="organization && modulesService.modulesAreSet && modulesService.hasGoogleCalendar()" class="profile-box info-box general mt-12 flex-column" >
                    <div class="gt2-org-theme">
                    <header class="accent">
                        <div class="title">{{ 'GENERIC.GOOGLE_CALENDER' | translate }}</div>
                    </header>
                    </div>
                    <div class="content">
                        Google Calendar - À venir
                    </div>
                </div>-->

        <!--<div *ngIf="organization && modulesService.modulesAreSet && modulesService.hasShopWeb()" class="profile-box info-box general mt-12 flex-column" >
                    <div class="gt2-org-theme">
                    <header class="accent">
                        <div class="title">{{ 'GENERIC.STRIPE' | translate }}</div>
                    </header>
                    </div>
                    <div class="content">
                        Stripe - À venir
                    </div>
                </div>-->

        <!--<div *ngIf="organization && modulesService.modulesAreSet && modulesService.hasShopWeb()" class="profile-box info-box general mt-12 flex-column" >
                    <div class="gt2-org-theme">
                    <header class="accent">
                        <div class="title">{{ 'GENERIC.SHOP_WEB' | translate }}</div>
                    </header>
                    </div>
                    <div class="content">
                        Web shop - À venir
                    </div>
                </div>-->
      </div>
      <!-- / CONTENT -->
    </div>
    <!-- / CENTER -->
  </div>
</div>

<div *ngIf="organization" class="flex-row-end-start">
  <div *ngxPermissionsOnly="P.CONFIG_ORGANIZATION">
    <div class="fixed-button">
      <button
        mat-fab
        appEditShortcut
        class="gt2-edit-button"
        id="edit-organization-button"
        [disabled]="loading"
        [matTooltip]="
          editMode
            ? ('GENERIC.SAVE' | translate) + ' (F2)'
            : ('GENERIC.EDIT' | translate) + ' (F2)'
        "
        (click)="onEdit($event)"
        *fuseIfOnDom
        [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
      >
        <mat-icon *ngIf="!editMode" class="icon-mat-black">{{
          getIcon("EDIT_FAB")
        }}</mat-icon>
        <mat-icon *ngIf="editMode" class="icon-mat-black">{{
          getIcon("UNDO")
        }}</mat-icon>
      </button>
    </div>
  </div>
</div>
